//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

//CreateUpdate Communication
const createCommunicationStatusDataSelector = (state: RootState) => state.admin.affiliateProfile.communicationCreate.data;
const createCommunicationStatusErrorSelector = (state: RootState) => state.admin.affiliateProfile.communicationCreate.error;
const createCommunicationStatusFetchingSelector = (state: RootState) => state.admin.affiliateProfile.communicationCreate.isFetching;

export const selectCreateCommunicationStatusData = createSelector(createCommunicationStatusDataSelector, (data) => data);
export const selectCreateCommunicationStatusError = createSelector(createCommunicationStatusErrorSelector, (error) => error);
export const selectCreateCommunicationStatusIsFetching = createSelector(createCommunicationStatusFetchingSelector, (isFetching) => isFetching);

//Delete Communication
const communicationDeleteDataSelector = (state: RootState) => state.admin.affiliateProfile.communicationDelete.data;
const communicationDeleteErrorSelector = (state: RootState) => state.admin.affiliateProfile.communicationDelete.error;
const communicationDeleteFetchingSelector = (state: RootState) => state.admin.affiliateProfile.communicationDelete.isFetching;

export const selectCommunicationDeleteData = createSelector(communicationDeleteDataSelector, (data) => data);
export const selectCommunicationDeleteError = createSelector(communicationDeleteErrorSelector, (error) => error);
export const selectCommunicationDeleteIsFetching = createSelector(communicationDeleteFetchingSelector, (isFetching) => isFetching);

// Communication History
const communicationHistoryDataSelector = (state: RootState) => state.admin.affiliateProfile.communicationHistory.data;
const communicationHistoryErrorSelector = (state: RootState) => state.admin.affiliateProfile.communicationHistory.error;
const communicationHistoryFetchingSelector = (state: RootState) => state.admin.affiliateProfile.communicationHistory.isFetching;

export const selectCommunicationHistoryData = createSelector(communicationHistoryDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'communication_status') {
        return { ...item, type: 'communicationHistoryStatus' };
      }
      if (item.name === 'affiliate_id') {
        return { ...item, type: 'string' };
      }
      if (item.name === 'created_by') {
        return { ...item, type: 'createdBy' };
      }
      if (item.name === 'updated_by') {
        return { ...item, type: 'updatedBy' };
      }
      if (item.name === 'communication_date') {
        return { ...item, type: 'fulldatetime' };
      }
      if (item.name === 'notes') {
        return { ...item, type: 'notes' };
      }
      if (item.name === 'is_email_sent') {
        return { ...item, type: 'badge' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data;
  }
});
export const selectCommunicationHistoryError = createSelector(communicationHistoryErrorSelector, (error) => error);
export const selectCommunicationHistoryIsFetching = createSelector(communicationHistoryFetchingSelector, (isFetching) => isFetching);


//Delete Communication
const communicationUpdateDataSelector = (state: RootState) => state.admin.affiliateProfile.communicationUpdate.data;
const communicationUpdateErrorSelector = (state: RootState) => state.admin.affiliateProfile.communicationUpdate.error;
const communicationUpdateFetchingSelector = (state: RootState) => state.admin.affiliateProfile.communicationUpdate.isFetching;

export const selectCommunicationUpdateData = createSelector(communicationUpdateDataSelector, (data) => data);
export const selectCommunicationUpdateError = createSelector(communicationUpdateErrorSelector, (error) => error);
export const selectCommunicationUpdateIsFetching = createSelector(communicationUpdateFetchingSelector, (isFetching) => isFetching)


//Update traffic status
const trafficStatusUpdateDataSelector = (state: RootState) => state.admin.affiliateProfile.trafficStatusUpdate.data;
const trafficStatusUpdateErrorSelector = (state: RootState) => state.admin.affiliateProfile.trafficStatusUpdate.error;
const trafficStatusUpdateFetchingSelector = (state: RootState) => state.admin.affiliateProfile.trafficStatusUpdate.isFetching;

export const selectTrafficStatusUpdateData = createSelector(trafficStatusUpdateDataSelector, (data) => data);
export const selectTrafficStatusUpdateError = createSelector(trafficStatusUpdateErrorSelector, (error) => error);
export const selectTrafficStatusUpdateIsFetching = createSelector(trafficStatusUpdateFetchingSelector, (isFetching) => isFetching);


//Profile
const profileDataSelector = (state: RootState) => state.admin.affiliateProfile.profile.data;
const profileErrorSelector = (state: RootState) => state.admin.affiliateProfile.profile.error;
const profileFetchingSelector = (state: RootState) => state.admin.affiliateProfile.profile.isFetching;

export const selectProfileData = createSelector(profileDataSelector, (data) => data);
export const selectProfileError = createSelector(profileErrorSelector, (error) => error);
export const selectProfileIsFetching = createSelector(profileFetchingSelector, (isFetching) => isFetching);

//Update Profile
const updateProfileDataSelector = (state: RootState) => state.admin.affiliateProfile.updateProfile.data;
const updateProfileErrorSelector = (state: RootState) => state.admin.affiliateProfile.updateProfile.error;
const updateProfileFetchingSelector = (state: RootState) => state.admin.affiliateProfile.updateProfile.isFetching;

export const selectUpdateProfileData = createSelector(updateProfileDataSelector, (data) => data);
export const selectUpdateProfileError = createSelector(updateProfileErrorSelector, (error) => error);
export const selectUpdateProfileIsFetching = createSelector(updateProfileFetchingSelector, (isFetching) => isFetching);

//Update Chiefs
const updateChiefsDataSelector = (state: RootState) => state.admin.affiliateProfile.updateChiefs.data;
const updateChiefsErrorSelector = (state: RootState) => state.admin.affiliateProfile.updateChiefs.error;
const updateChiefsFetchingSelector = (state: RootState) => state.admin.affiliateProfile.updateChiefs.isFetching;

export const selectUpdateChiefsData = createSelector(updateChiefsDataSelector, (data) => data);
export const selectUpdateChiefsError = createSelector(updateChiefsErrorSelector, (error) => error);
export const selectUpdateChiefsIsFetching = createSelector(updateChiefsFetchingSelector, (isFetching) => isFetching);


//payment list
const paymentListDataSelector = (state: RootState) => state.admin.affiliateProfile.paymentList.data;
const paymentListErrorSelector = (state: RootState) => state.admin.affiliateProfile.paymentList.error;
const paymentListFetchingSelector = (state: RootState) => state.admin.affiliateProfile.paymentList.isFetching;
export const selectPaymentListData = createSelector(paymentListDataSelector, (data) => data);
export const selectPaymentListError = createSelector(paymentListErrorSelector, (error) => error);
export const selectPaymentListIsFetching = createSelector(paymentListFetchingSelector, (isFetching) => isFetching);


//payment Methods
const paymentMethodsDataSelector = (state: RootState) => state.admin.affiliateProfile.paymentMethods.data;
const paymentMethodsErrorSelector = (state: RootState) => state.admin.affiliateProfile.paymentMethods.error;
const paymentMethodsFetchingSelector = (state: RootState) => state.admin.affiliateProfile.paymentMethods.isFetching;
export const selectPaymentMethodsData = createSelector(paymentMethodsDataSelector, (data) => data);
export const selectPaymentMethodsError = createSelector(paymentMethodsErrorSelector, (error) => error);
export const selectPaymentMethodsIsFetching = createSelector(paymentMethodsFetchingSelector, (isFetching) => isFetching);


//Create payment Methods
const createPaymentMethodDataSelector = (state: RootState) => state.admin.affiliateProfile.createPaymentMethod.data;
const createPaymentMethodErrorSelector = (state: RootState) => state.admin.affiliateProfile.createPaymentMethod.error;
const createPaymentMethodFetchingSelector = (state: RootState) => state.admin.affiliateProfile.createPaymentMethod.isFetching;
export const selectCreatePaymentMethodData = createSelector(createPaymentMethodDataSelector, (data) => data);
export const selectCreatePaymentMethodError = createSelector(createPaymentMethodErrorSelector, (error) => error);
export const selectCreatePaymentMethodIsFetching = createSelector(createPaymentMethodFetchingSelector, (isFetching) => isFetching);


//Delete payment Methods
const deletePaymentMethodDataSelector = (state: RootState) => state.admin.affiliateProfile.deletePaymentMethod.data;
const deletePaymentMethodErrorSelector = (state: RootState) => state.admin.affiliateProfile.deletePaymentMethod.error;
const deletePaymentMethodFetchingSelector = (state: RootState) => state.admin.affiliateProfile.deletePaymentMethod.isFetching;
export const selectDeletePaymentMethodData = createSelector(deletePaymentMethodDataSelector, (data) => data);
export const selectDeletePaymentMethodError = createSelector(deletePaymentMethodErrorSelector, (error) => error);
export const selectDeletePaymentMethodIsFetching = createSelector(deletePaymentMethodFetchingSelector, (isFetching) => isFetching);


//Update payment Methods
const updatePaymentMethodDataSelector = (state: RootState) => state.admin.affiliateProfile.updatePaymentMethod.data;
const updatePaymentMethodErrorSelector = (state: RootState) => state.admin.affiliateProfile.updatePaymentMethod.error;
const updatePaymentMethodFetchingSelector = (state: RootState) => state.admin.affiliateProfile.updatePaymentMethod.isFetching;
export const selectUpdatePaymentMethodData = createSelector(updatePaymentMethodDataSelector, (data) => data);
export const selectUpdatePaymentMethodError = createSelector(updatePaymentMethodErrorSelector, (error) => error);
export const selectUpdatePaymentMethodIsFetching = createSelector(updatePaymentMethodFetchingSelector, (isFetching) => isFetching);


//payment history
const paymentHistoryDataSelector = (state: RootState) => state.admin.affiliateProfile.paymentHistory.data;
const paymentHistoryErrorSelector = (state: RootState) => state.admin.affiliateProfile.paymentHistory.error;
const paymentHistoryFetchingSelector = (state: RootState) => state.admin.affiliateProfile.paymentHistory.isFetching;
export const selectPaymentHistoryData = createSelector(paymentHistoryDataSelector, (data) => data);
export const selectPaymentHistoryError = createSelector(paymentHistoryErrorSelector, (error) => error);
export const selectPaymentHistoryIsFetching = createSelector(paymentHistoryFetchingSelector, (isFetching) => isFetching);

//Edit Email
const editEmailDataSelector = (state: RootState) => state.admin.affiliateProfile.editEmail.data;
const editEmailErrorSelector = (state: RootState) => state.admin.affiliateProfile.editEmail.error;
const editEmailFetchingSelector = (state: RootState) => state.admin.affiliateProfile.editEmail.isFetching;

export const selectEditEmailData = createSelector(editEmailDataSelector, (data) => data);
export const selectEditEmailError = createSelector(editEmailErrorSelector, (error) => error);
export const selectEditEmailIsFetching = createSelector(editEmailFetchingSelector, (isFetching) => isFetching);


//additiona info
const additionalInfoDataSelector = (state: RootState) => state.admin.affiliateProfile.additionalInfo.data;
const additionalInfoErrorSelector = (state: RootState) => state.admin.affiliateProfile.additionalInfo.error;
const additionalInfoFetchingSelector = (state: RootState) => state.admin.affiliateProfile.additionalInfo.isFetching;

export const selectAdditionalInfoData = createSelector(additionalInfoDataSelector, (data) => data);
export const selectAdditionalInfoError = createSelector(additionalInfoErrorSelector, (error) => error);
export const selectAdditionalInfoIsFetching = createSelector(additionalInfoFetchingSelector, (isFetching) => isFetching);

//update additiona info
const updateAdditionalInfoDataSelector = (state: RootState) => state.admin.affiliateProfile.updateOtherInfo.data;
const updateAdditionalInfoErrorSelector = (state: RootState) => state.admin.affiliateProfile.updateOtherInfo.error;
const updateAdditionalInfoFetchingSelector = (state: RootState) => state.admin.affiliateProfile.updateOtherInfo.isFetching;

export const selectUpdateAdditionalInfoData = createSelector(updateAdditionalInfoDataSelector, (data) => data);
export const selectUpdateAdditionalInfoError = createSelector(updateAdditionalInfoErrorSelector, (error) => error);
export const selectUpdateAdditionalInfoIsFetching = createSelector(updateAdditionalInfoFetchingSelector, (isFetching) => isFetching);

//Preview email sent
const previewEmailSentDataSelector = (state: RootState) => state.admin.affiliateProfile.previewEmailSent.data;
const previewEmailSentErrorSelector = (state: RootState) => state.admin.affiliateProfile.previewEmailSent.error;
const previewEmailSentFetchingSelector = (state: RootState) => state.admin.affiliateProfile.previewEmailSent.isFetching;

export const selectPreviewEmailSentData = createSelector(previewEmailSentDataSelector, (data) => data);
export const selectPreviewEmailSentError = createSelector(previewEmailSentErrorSelector, (error) => error);
export const selectPreviewEmailSentIsFetching = createSelector(previewEmailSentFetchingSelector, (isFetching) => isFetching);


//Notes
const notesListDataSelector = (state: RootState) => state.admin.affiliateProfile.notes.data;
const notesListErrorSelector = (state: RootState) => state.admin.affiliateProfile.notes.error;
const notesListFetchingSelector = (state: RootState) => state.admin.affiliateProfile.notes.isFetching;

export const selectNotesListData = createSelector(notesListDataSelector, (data) => {
  if (!!data) {
    const list = data.list.map((item: any) => ({
      ...item,
      created_by: {
        username: item.created_by?.name,
        id: item.created_by?.id,
      },
      updated_by: {
        username: item.updated_by?.name,
        id: item.updated_by?.id,
      }
    }));

    return { ...data, list: list };
  } else {
    return data;
  }
});
export const selectNotesListError = createSelector(notesListErrorSelector, (error) => error);
export const selectNotesListIsFetching = createSelector(notesListFetchingSelector, (isFetching) => isFetching);

// Create selectors
const noteCreateDataSelector = (state: RootState) => state.admin.affiliateProfile.createNote.data;
const noteCreateErrorSelector = (state: RootState) => state.admin.affiliateProfile.createNote.error;
const noteCreateLoadingSelector = (state: RootState) => state.admin.affiliateProfile.createNote.isFetching;

export const selectNoteCreateData = createSelector(noteCreateDataSelector, (data) => data);
export const selectNoteCreateError = createSelector(noteCreateErrorSelector, (error) => error);
export const selectNoteCreateLoading = createSelector(noteCreateLoadingSelector, (isFetching) => isFetching);

// Delete selectors
const noteDeleteDataSelector = (state: RootState) => state.admin.affiliateProfile.deleteNote.data;
const noteDeleteErrorSelector = (state: RootState) => state.admin.affiliateProfile.deleteNote.error;
const noteDeleteLoadingSelector = (state: RootState) => state.admin.affiliateProfile.deleteNote.isFetching;

export const selectNoteDeleteData = createSelector(noteDeleteDataSelector, (data) => data);
export const selectNoteDeleteError = createSelector(noteDeleteErrorSelector, (error) => error);
export const selectNoteDeleteLoading = createSelector(noteDeleteLoadingSelector, (isFetching) => isFetching);

// Update selectors
const noteUpdateDataSelector = (state: RootState) => state.admin.affiliateProfile.updateNote.data;
const noteUpdateErrorSelector = (state: RootState) => state.admin.affiliateProfile.updateNote.error;
const noteUpdateLoadingSelector = (state: RootState) => state.admin.affiliateProfile.updateNote.isFetching;

export const selectNoteUpdateData = createSelector(noteUpdateDataSelector, (data) => data);
export const selectNoteUpdateError = createSelector(noteUpdateErrorSelector, (error) => error);
export const selectNoteUpdateLoading = createSelector(noteUpdateLoadingSelector, (isFetching) => isFetching);

// Pin selectors
const notePinUnpinDataSelector = (state: RootState) => state.admin.affiliateProfile.pinUnpinNote.data;
const notePinUnpinErrorSelector = (state: RootState) => state.admin.affiliateProfile.pinUnpinNote.error;
const notePinUnpinLoadingSelector = (state: RootState) => state.admin.affiliateProfile.pinUnpinNote.isFetching;

export const selectPinUnpinNoteData = createSelector(notePinUnpinDataSelector, (data) => data);
export const selectPinUnpinNoteError = createSelector(notePinUnpinErrorSelector, (error) => error);
export const selectPinUnpinNoteLoading = createSelector(notePinUnpinLoadingSelector, (isFetching) => isFetching);

//Get Account Id
const getAccountIdDataSelector = (state: RootState) => state.admin.affiliateProfile.accountId.data;
const getAccountIdErrorSelector = (state: RootState) => state.admin.affiliateProfile.accountId.error;
const getAccountIdFetchingSelector = (state: RootState) => state.admin.affiliateProfile.accountId.isFetching;

export const selectGetAccountIdData = createSelector(getAccountIdDataSelector, (data) => data);
export const selectGetAccountIdError = createSelector(getAccountIdErrorSelector, (error) => error);
export const selectGetAccountIdIsFetching = createSelector(getAccountIdFetchingSelector, (isFetching) => isFetching);

//Update Account Id
const updateAccountIdDataSelector = (state: RootState) => state.admin.affiliateProfile.updateAccountId.data;
const updateAccountIdErrorSelector = (state: RootState) => state.admin.affiliateProfile.updateAccountId.error;
const updateAccountIdFetchingSelector = (state: RootState) => state.admin.affiliateProfile.updateAccountId.isFetching;

export const selectUpdateAccountIdData = createSelector(updateAccountIdDataSelector, (data) => data);
export const selectUpdateAccountIdError = createSelector(updateAccountIdErrorSelector, (error) => error);
export const selectUpdateAccountIdIsFetching = createSelector(updateAccountIdFetchingSelector, (isFetching) => isFetching);